export interface Destination {
  id: string;
  name: string;
  subtitle?: string;
  type: string;
  description: string;
  highlights: string[];
  tips: string;
  mapyUrl?: string;
  googleMapsUrl?: string;
  slCardInfo?: string;
  noteKey: string;
  cableCarHours?: string;
  openingHours?: string;
  cableCarDuration?: string;
  dogPrice?: string;
  dogInfo?: string;
  groupPriceNormal?: string;
  groupPriceCard?: string;
  webUrl?: string;
  coords?: [number, number];
  imageUrl: string;
}

export const destinations: Destination[] = [
  {
    id: 'elektro',
    name: 'Elektrozavodsk (Povrly)',
    subtitle: 'Průmyslové centrum na pobřeží Labe',
    type: 'Industriální zóna & Pobřeží',
    description:
      'Obec Povrly a přilehlá osada Mírová slouží jako přímá předloha pro jedno z nejznámějších pobřežních měst v DayZ - Elektrozavodsk. Najdeme zde typické industriální haly, železniční trať a Labe suplující Černaruské moře. Výchozí a koncový bod naší cesty.',
    highlights: [
      'Přístavní a železniční koridor kopírující herní atmosféru',
      'Industriální siluety továren a vysoký tovární komín',
      'Místní obchody pro závěrečný loot jídla a piva po dokončení okruhu',
    ],
    tips: 'Zaparkujeme auta v Mírové, kde trasa oficiálně začíná a končí. Nezapomeňte si naplnit PET lahve pitnou vodou.',
    mapyUrl: 'https://mapy.cz/turisticka?source=muni&id=1626',
    googleMapsUrl: 'https://www.google.com/maps?q=Povrly',
    slCardInfo: 'Loot Tier: Nízký (pobřežní zóna, hodně čerstvých spawnů)',
    noteKey: 'note_elektro',
    openingHours: 'Přístupno nonstop',
    dogPrice: 'Nebezpečí: Nízké (Freshie zóna)',
    dogInfo:
      'Oblast je relativně bezpečná, ale pozor na ostatní hráče (freshies), kteří nemají co ztratit a rádi útočí pěstmi. Zombie se vyskytují hlavně kolem kolejí a opuštěných budov.',
    groupPriceNormal: 'Vzdálenost od pobřeží: 0 km (Spawn)',
    groupPriceCard: 'Stamina: 100 % (Plná stamina před startem)',
    webUrl: 'https://www.povrly.cz',
    coords: [50.67127, 14.15809],
    imageUrl: '/images/destinations/elektro.webp',
  },
  {
    id: 'pusta',
    name: 'Pusta (Mašovice)',
    subtitle: 'Malá vnitrozemská osada v kopcích',
    type: 'Vnitrozemská vesnice',
    description:
      'Tato malebná česká víska s hrstkou domů uprostřed pastvin a lesů posloužila vývojářům z Bohemia Interactive jako předloha pro herní vesnici Pusta. V herním světě je známá svými typickými dřevěnými stodolami a poměrně klidnou atmosférou.',
    highlights: [
      'Tradiční dřevěné stodoly a zemědělská stavení',
      'Studna v centru osady pro rychlé zahnání žízně',
      'Klidné cesty obklopené zelenými loukami a remízky',
    ],
    tips: 'Cesta z Mírové sem vede strmě do kopce. Šetřete síly a zbytečně nesprintujte, ať vám nedojde jídlo a voda příliš brzy.',
    mapyUrl: 'https://mapy.cz/turisticka?source=muni&id=5165',
    googleMapsUrl: 'https://www.google.com/maps?q=Ma%C5%A1ovice+Povrly',
    slCardInfo: 'Loot Tier: Střední (civilní oblečení, konzervy, lovecké náboje)',
    noteKey: 'note_pusta',
    openingHours: 'Přístupno nonstop',
    dogPrice: 'Nebezpečí: Střední (Inland)',
    dogInfo:
      'Zombie se mohou potulovat kolem stodol a zahrad. Většinou je ale snadné se jim vyhnout nebo je obejít přes lesní stezku.',
    groupPriceNormal: 'Vzdálenost od pobřeží: cca 3 km',
    groupPriceCard: 'Stamina: cca 80 % (Náročnější stoupání z Elektro)',
    webUrl: 'https://cs.wikipedia.org/wiki/Ma%C5%A1ovice_(Povrly)',
    coords: [50.68652, 14.13783],
    imageUrl: '/images/destinations/pusta.webp',
  },
  {
    id: 'devils_castle',
    name: "Devil's Castle (Hrad Blansko)",
    subtitle: 'Monumentální zřícenina na čedičovém vrchu',
    type: 'Hradní zřícenina',
    description:
      "Zřícenina hradu Blansko z 15. století leží ve výšce 545 m n. m. a je přímou předlohou pro ikonický Devil's Castle v DayZ. Z dochované hradní věže upravené na rozhlednu je famózní kruhový výhled na České středohoří a Krušné hory.",
    highlights: [
      'Hradní věž s vyhlídkovou plošinou a 360° panoramatem',
      'Pozůstatky obvodových zdi a skalního příkopu kopírující herní rozložení',
      'Strmá čedičová skála, na které hrad stojí a ztěžuje přístup zespoda',
    ],
    tips: 'Perfektní spot pro odstřelovače a ideální místo na polední pauzu a oběd z vlastních zásob. Pozor na silný vítr nahoře na věži.',
    mapyUrl: 'https://mapy.cz/turisticka?source=base&id=1701731',
    googleMapsUrl: 'https://www.google.com/maps?q=Hrad+Blansko',
    slCardInfo: 'Loot Tier: Vysoký (vojenské a lovecké zbraně, nože, batohy)',
    noteKey: 'note_devils_castle',
    openingHours: 'Celoročně volně přístupný',
    dogPrice: 'Nebezpečí: Vysoké (Populární PvP a vyhlídkový spot)',
    dogInfo:
      'Kvůli skvělému výhledu je toto místo velmi oblíbené u ostatních přeživších. Mějte oči na stopkách a buďte připraveni na kontakt. Schody na věž jsou úzké a strmé.',
    groupPriceNormal: 'Vzdálenost od pobřeží: cca 6.5 km',
    groupPriceCard: 'Stamina: cca 50 % (Strmý skalní výstup a schody)',
    webUrl: 'https://www.hrady.cz/hrad-blansko-usti-nad-labem',
    coords: [50.70714, 14.10392],
    imageUrl: '/images/destinations/devils_castle.webp',
  },
  {
    id: 'kabanino',
    name: 'Kabanino (Mnichov)',
    subtitle: 'Klíčová vnitrozemská vesnice na křižovatce',
    type: 'Vnitrozemská vesnice',
    description:
      'Vesnička Mnichov u Velkého Chvojna je předlohou pro Kabanino v DayZ. Nachází se na strategické vnitrozemské křižovatce, kterou prochází většina hráčů mířících na obávané severozápadní letiště (NWAF). Okolní rozlehlá pole a remízky jsou ideálním místem pro přepadení.',
    highlights: [
      'Náves s křižovatkou a typickými venkovskými domy',
      'Otevřená pole a pastviny všude kolem s minimem krytí',
      'Zvlněná krajina přecházející v hluboké lesy Krušných hor',
    ],
    tips: 'Při průchodu kolem obce se držte v krytu stromů. Otevřená pole kolem Kabanina jsou rájem pro ostrostřelce s dalekonosnými zbraněmi.',
    mapyUrl: 'https://mapy.cz/turisticka?source=muni&id=3249',
    googleMapsUrl: 'https://www.google.com/maps?q=Mnichov+Velk%C3%A9+Chvojno',
    slCardInfo: 'Loot Tier: Střední (jídlo, nářadí, semínka zeleniny, zdravotnické potřeby)',
    noteKey: 'note_kabanino',
    openingHours: 'Přístupno nonstop',
    dogPrice: 'Nebezpečí: Vysoké (Blízkost vojenské cesty)',
    dogInfo:
      'Poloha na hlavním tahu k letišti znamená zvýšené riziko kontaktu s nepřátelskými skupinami. Vždy postupujte obezřetně a kryjte si záda.',
    groupPriceNormal: 'Vzdálenost od pobřeží: cca 11 km',
    groupPriceCard: 'Stamina: cca 30 % (Dlouhý pochod přes pole a louky)',
    webUrl: 'https://cs.wikipedia.org/wiki/Mnichov_(Velk%C3%A9_Chvojno)',
    coords: [50.72621, 14.07724],
    imageUrl: '/images/destinations/kabanino.webp',
  },
  {
    id: 'grishino',
    name: 'Grishino (Čermná)',
    subtitle: 'Severní základna u letištního plotu',
    type: 'Severní vnitrozemská vesnice',
    description:
      'Vesnice Čermná odpovídá hernímu Grišinu. Leží na samém severním cípu naší trasy, přímo v podhůří Krušných hor. V herním světě leží v těsném sousedství Northwest Airfield (NWAF), což z ní dělá zónu s extrémně vysokým nebezpečím a častou střelbou.',
    highlights: [
      'Typický vesnický rybník uprostřed návsi',
      'Okolní pastviny, zemědělská družstva a staré stodoly',
      'Napojení na husté severní lesy a únikové cesty',
    ],
    tips: 'Jedná se o poslední bod naší cesty před odbočením do Safezone v Jílovém. Zkontrolujte stav zásob a zdraví celého týmu.',
    mapyUrl: 'https://mapy.cz/turisticka?source=muni&id=1623',
    googleMapsUrl: 'https://www.google.com/maps?q=%C4%8Cermn%C3%A1+Libouchec',
    slCardInfo: 'Loot Tier: Vysoký (vojenský materiál, zbraně, munice, helmy, vesty)',
    noteKey: 'note_grishino',
    openingHours: 'Přístupno nonstop',
    dogPrice: 'Nebezpečí: Extrémní (Těsná blízkost NWAF)',
    dogInfo:
      'Nejrizikovější zóna na trase. Zombie jsou zde velmi agresivní a ostatní přeživší střílí bez varování. Doporučujeme plné utajení a rychlý přesun.',
    groupPriceNormal: 'Vzdálenost od pobřeží: cca 13.5 km',
    groupPriceCard: 'Stamina: cca 20 % (Značná únava po celém dni pochodu)',
    webUrl: 'https://cs.wikipedia.org/wiki/%C4%8Cermn%C3%A1_(Libouchec)',
    coords: [50.73031, 14.09081],
    imageUrl: '/images/destinations/grishino.webp',
  },
  {
    id: 'safezone',
    name: 'Safezone (Northern Panorama)',
    subtitle: 'Útočiště pro přečkání noci a plnou regeneraci',
    type: 'Safezone & Apartmán',
    description:
      'Apartmán Northern Panorama v Jílovém u Děčína představuje naši Safezone na konci prvního dne pochodu. Zde platí přísný zákaz PvP (Player vs Player). Je to bezpečné místo pro teplou sprchu, uvaření teplého jídla, odpočinek a regeneraci životních funkcí.',
    highlights: [
      'Plně vybavená kuchyň pro přípravu teplé večeře a čaje',
      'Terasa s výhledem na panorama okolních severočeských kopců',
      'Pohodlné postele a bezpečné zázemí bez hrozby napadení',
    ],
    tips: 'Check-in je od 15:00. Ubytování vyžaduje bankovní převod předem, kód ke schránce s klíčem obdržíte v SMS. Uložte si zásoby jídla do lednice.',
    mapyUrl: 'https://mapy.cz/turisticka?source=firm&id=13649183',
    googleMapsUrl: 'https://www.google.com/maps?cid=1257292701_399721099_4_0_0',
    slCardInfo: 'Loot Tier: Safezone (žádné nebezpečí, čistý komfort)',
    noteKey: 'note_safezone',
    openingHours: 'Check-in: od 15:00, Check-out: do 10:00',
    dogPrice: 'Nebezpečí: Žádné (Green Zone / Safezone)',
    dogInfo:
      'Zde jste v naprostém bezpečí před zombíky i nepřátelskými hráči. K dispozici je stabilní Wi-Fi pro plánování postupu na druhý den.',
    groupPriceNormal: 'Cena za noc: cca 2 500 Kč (pro celou skupinu 4 dospělých)',
    groupPriceCard: 'Sleva: Dle aktuálních nabídek na Booking.com',
    webUrl: 'https://www.booking.com/hotel/cz/northern-panorama.cs.html',
    coords: [50.76077, 14.10398],
    imageUrl: '/images/destinations/severograd.webp',
  },
];
